import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { isEmptyOrNull } from '@/shared/utils/string';

/**
 * Fetches a single organization by its ID. The response includes full details
 * such as name, tags, geo area, and role of the current user within the org.
 *
 * @param id - The organization's unique identifier
 * @returns Query result containing the organization data or error state
 */
export const useGetOrganizationById = (id = '') => {
  const api = useGrapevineOrganizationApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.ORGANIZATION, id],
    queryFn: () => api.getOrganizationById({ organizationId: id }),
    enabled: !isEmptyOrNull(id),
    ...DATA_INIT_CACHING
  });
};
